import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import DateRangePickerComponent from "../common/DateRangePickerComponent/DateRangePickerComponent";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { textColors, useClasses } from "../Invoices/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import Button from "@material-ui/core/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Skeleton from "@material-ui/lab/Skeleton";
import { usePrevious } from "../common/CustomHook/usePrevious";
import Preloader from "../common/Preloader/Preloader";
import Pagination from "@material-ui/lab/Pagination";
import Typography from "@material-ui/core/Typography";


const RenderFilters = ({ object = null, roomsList = {}, filter = {}, setFilter, setPage }, props) => {


  const filterClearValues = {
    datesHistory: [null, null],
    object: object,
    rooms: [],
  };

  const onSubmit = values => {
    setPage(1)
    setFilter(values)
  }


  return (
    <div className="filters mb-2">
      <Formik initialValues={filter}
              onSubmit={onSubmit}
              enableReinitialize>
        {({ handleSubmit, setFieldValue, setValues, values }) => {
          const handleClearFilterFields = () => {
            setValues(filterClearValues);
            setFilter(filterClearValues);
          }

          return (

            <Form onSubmit={handleSubmit}>

              <div className="row g-2 ">
                <div className="col-lg-4 h-100">
                  <DateRangePickerComponent
                    name="datesHistory"
                    startText="Дата отзыва, от"
                    endText="Дата отзыва, до"
                  />
                </div>

                <div className="col-lg-2 h-100">
                  <MuiThemeProvider theme={textColors}>
                    <Field name="rooms">
                      {({ field, form }) => (
                        <FormControl variant="outlined" size="small"
                                     className="w-100 mb-1 long-multiple-select">
                          <InputLabel htmlFor={`${field.name}_id`}>Номер</InputLabel>
                          <Select
                            {...field}
                            id={`${field.name}_id`}
                            multiple
                            displayEmpty
                            label="Гостевой объект"
                            renderValue={selected => selected.map((key) => roomsList.find(room => room.id == key).name).join(', ')}
                          >
                            {
                              Object.keys(roomsList).map((room) => {

                                return (
                                  <MenuItem key={roomsList[room].id}
                                            value={roomsList[room].id}>
                                    <Checkbox
                                      checked={field.value.indexOf(roomsList[room].id) > -1}
                                    />
                                    <ListItemText primary={roomsList[room].name}/>
                                  </MenuItem>
                                )
                              })
                            }
                          </Select>
                        </FormControl>
                      )}
                    </Field>
                  </MuiThemeProvider>
                </div>
                <div className="col-lg-6 h-100">
                  <div className="filters-btns">
                    <Button type="submit" className="btn filters-btn">
                      <FontAwesomeIcon icon={"search"} className="me-1"/> поиск
                    </Button>
                    <Button className="btn filters-btn" onClick={handleClearFilterFields}>
                      очистить
                    </Button>
                  </div>
                </div>
              </div>

            </Form>
          )
        }}
      </Formik>
    </div>
  )
}


const RenderHistoryRow = ({
  id,
  entityName,
  entityType,
  fieldLabel,
  fieldName,
  modifiedBy,
  modifiedByIP,
  newValue,
  oldValue,
  timestamp
}) => {


  return (
    <tr className="c-table__row">
      <td className=" c-table__cell">
        <span className="cell__title-mobile">№</span>
        {id}
      </td>
      <td className=" c-table__cell">
        <span className="cell__title-mobile">Что изменили</span>
        {entityType === 'room' ? 'Номер' : 'Объект'}
      </td>
      <td className=" c-table__cell">
        <span className="cell__title-mobile">Название</span>
        {entityName}
      </td>
      <td className="c-table__cell">
        <span className="cell__title-mobile">Кто изменил / ip</span>
        <p className="mb-2">{modifiedBy}</p>
        <Typography variant="caption" className="mb-0">({modifiedByIP})</Typography>
      </td>
      <td className="c-table__cell">
        <span className="cell__title-mobile">Когда изменили</span>
        {timestamp}
      </td>
      <td className="c-table__cell">
        <span className="cell__title-mobile">Измененное поле / id поля</span>
        <p className="mb-2">{fieldLabel}</p>
        <Typography variant="caption" className="mb-0 ">({fieldName})</Typography>
      </td>
      <td className="c-table__cell">
        <span className="cell__title-mobile">Старое значение</span>
        <div dangerouslySetInnerHTML={{ __html: oldValue || "" }}></div>
      </td>
      <td className="c-table__cell">
        <span className="cell__title-mobile">Новое значение</span>
        <div dangerouslySetInnerHTML={{ __html: newValue || "" }}></div>
      </td>

    </tr>
  )
}

const RenderHistoryTable = ({ history }) => {
  let skeletonCell = []
  for (let i = 0; i < 49; i++) {
    skeletonCell.push(<Skeleton animation='wave' key={i} height={35} variant='rect'/>)
  }


  if (!history) {
    return (
      <>
        <div style={{ display: 'flex' }}>
          <Skeleton style={{ marginBottom: 5, flex: '1 1 auto' }} animation='wave' height={35}
                    variant='rect'/>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: "repeat(7, 1fr)", gridGap: "5px" }}>
          {skeletonCell}
        </div>
      </>
    )
  }


  return (
    <table className="c-table">
      <thead className="c-table__row c-table__header">
      <tr>
        <th className="c-table__cell">
          №
        </th>
        <th className=" c-table__cell">
          Что изменили
        </th>
        <th className=" c-table__cell">
          Название
        </th>
        <th className=" c-table__cell">
          Кто изменил
        </th>
        <th className=" c-table__cell">
          Когда изменили / ip
        </th>
        <th className=" c-table__cell">
          Измененное поле / id поля
        </th>
        <th className=" c-table__cell">
          Старое значение
        </th>
        <th className=" c-table__cell">
          Новое значение
        </th>
      </tr>

      </thead>
      <tbody>

      {history.map((item, i) => <RenderHistoryRow key={item.id} {...item}/>)}

      </tbody>
    </table>
  )
}


const formatDate = (date) => {
  return `${date.toLocaleDateString('ru-RU')}`
}

const formatFilter = (filters) => {
  if (filters.datesHistory[0]) {
    filters.dateCreateFrom = formatDate(new Date(filters.datesHistory[0]));
  }
  if (filters.datesHistory[1]) {
    filters.dateCreateTo = formatDate(new Date(filters.datesHistory[1]));
  }
}


const History = (props) => {
  const [cachePagesWithNavParams, setCachePagesWithNavParams] = useState({});
  const [page, setPage] = useState(1);

  const {
    objectId,
    historyChange,
    navParams,
    getHistoryList,
    getHistoryNav,
    setHistoryListFromCache,
    setHistoryNavFromCache,
    roomsList
  } = props;


  // Состояние фильра
  let [filter, setFilter] = useState({
    datesHistory: [null, null],
    rooms: [],
    object: null
  });

  const prevObjectId = usePrevious(objectId)
  useEffect(() => {
    if (objectId !== prevObjectId) {
      setHistoryListFromCache(null);
    }
  }, [objectId])


  //общее количество выбранных фильтров
  const filtersCondition = [...filter.datesHistory, ...filter.rooms].filter(item => item).length


  // Т.к. в начальном фильтре не указаны объекты, нужно установить состояние фильтра и добавить туда ID объектов, если они уже пришли в props
  if (!filter.object && objectId) {
    setFilter({ ...filter, object: objectId });
  }

  const prevFilters = usePrevious(JSON.stringify(filter));

  useEffect(async () => {

    if (!cachePagesWithNavParams.hasOwnProperty(JSON.stringify(filter) + '_' + page)) {
      if (objectId) {
        let filterForRequest = JSON.parse(JSON.stringify(filter));
        formatFilter(filterForRequest);
        delete filterForRequest["datesHistory"]

        getHistoryList({
          filter: JSON.stringify(filterForRequest),
          page: page
        })

        if (prevFilters !== JSON.stringify(filter)) {
          getHistoryNav({
            filter: JSON.stringify(filterForRequest)
          });
        }
      }
    } else {
      setHistoryListFromCache(cachePagesWithNavParams[JSON.stringify(filter) + '_' + page]['items']);
      setHistoryNavFromCache(cachePagesWithNavParams[JSON.stringify(filter) + '_' + page]['navParams']);
    }
  }, [getHistoryList, filter, page])


  // После изменения страницы, сохраняем текущую в кеш (если её ещё там нет), со всеми установленными фильтрами
  const handleChange = (event, value) => {
    setHistoryListFromCache(null);
    if (!cachePagesWithNavParams.hasOwnProperty(JSON.stringify(filter) + '_' + page)) {
      let newPage = {};
      newPage[JSON.stringify(filter) + '_' + page] = {};
      newPage[JSON.stringify(filter) + '_' + page]['items'] = historyChange;
      newPage[JSON.stringify(filter) + '_' + page]['navParams'] = navParams;
      setCachePagesWithNavParams({ ...cachePagesWithNavParams, ...newPage });
    }
    setPage(value);

  };


  const classes = useClasses();
  if (!historyChange) {
    return <Preloader loading={true} text={"Загружаем истрию изменений..."}/>
  }
  return (
    <div className="main edit-object hide-fs">
      <div className="container-fluid">
        {historyChange?.length !== 0 && <RenderFilters objectId={objectId}
                                                       filter={filter}
                                                       setPage={setPage}
                                                       roomsList={roomsList}
                                                       setFilter={setFilter}/>}

        {navParams && navParams.pages > 1 &&
          <Pagination className={`${classes.pagination} mb-2 ms-auto`} count={navParams.pages} page={page}
                      onChange={handleChange}/>}


        <RenderHistoryTable history={historyChange}/>

        {historyChange && historyChange.length === 0 && <h6 className="w-100 text-center mt-5">
          {filtersCondition === 0
            ? "На выбранном объекте пока нет истории измененй"
            : "Нет изменений, по выбранным фильтрам"
          }
        </h6>}
      </div>
    </div>

  )
}

export default History
